import { useQuery } from 'react-query';
import { useCurrentUserCtx } from 'client/contexts/CurrentUser';
import { AnchorAPI } from '../../modules/AnchorAPI';

export const FETCH_EPISODE_OVERVIEW = 'episodeOverview';
function useFetchEpisodeOverview({ webEpisodeId }: { webEpisodeId: string }) {
  const {
    state: { userId },
  } = useCurrentUserCtx();

  const { data, status } = useQuery(
    [FETCH_EPISODE_OVERVIEW, webEpisodeId],
    () => AnchorAPI.fetchEpisodeOverview({ webEpisodeId }),
    {
      enabled: !!webEpisodeId && !!userId,
    }
  );

  return { episodeOverviewData: data, status };
}

export { useFetchEpisodeOverview };
